// extracted by mini-css-extract-plugin
export default {"wrapper":"total-withdraw_wrapper__X4l0u","buttons":"total-withdraw_buttons__8pgUv","opacity-transition":"total-withdraw_opacity-transition__CNl9f"};